/**
 * @author Jersson Morales
 * @Copyright (c) Infotrack. All rights reserved.
 */
import React from 'react';
import { useSelector } from 'react-redux';
import { connect } from 'react-redux';

import { useProveedor } from '@infotrack/presentacion-componentes/proveedorEstado';
import Texto from '@infotrack/presentacion-componentes/texto';
import { TipoFormulario } from '@infotrack/presentacion-transversales/interfacesComunes';
import { useInputState } from '@infotrack/presentacion-utilitarios/hooks';
import {
    manejadorDialogoGlobal,
    manejadorIndicadorCargaGlobal,
} from '@infotrack/presentacion-utilitarios/manejadoresComponentes';

import IPersona from 'Infotrack@Modelos/administracion/persona/entidades/persona';
import IBodegasPersonas from 'Infotrack@Modelos/smartStock/bodegasPersonas/entidades/bodegasPersonas';
import { IEstadoGlobal } from 'Infotrack@Reductores/interfacesReductores';
import BodegasPersonasCM from '../controladorModelo/bodegasPersonasCM';
import EntidadesBodegaPersonaCM from '../controladorModelo/entidadesBodegaPersonaCM';
import { IFormularioBodegasPersonasCVProps, IInputsBodegasPersonas } from '../interfaces';
import { acciones, IEstadoGestionBodegas } from '../reductorGestionBodegas';
import FormularioBodegasPersonasVista from '../vista/formularioBodegasPersonasVista';

const estadoInicial: IInputsBodegasPersonas = {
    BodegaId: '',
    Estado: true,
    Persona: null,
    EmpresaId: '',
    UsuarioId: '',
    BodegaPrincipal: false,
};
const bodegasPersonasCM = new BodegasPersonasCM();
const entidadesBodegaPersonaCM = new EntidadesBodegaPersonaCM();

const FormularioBodegasPersonasCV: React.FunctionComponent<IFormularioBodegasPersonasCVProps> = ({ IdEmpresa }) => {
    const idAgencia = useSelector((estado: IEstadoGlobal) => estado.estadoAutenticacion.agenciaActual);
    const idUsuario = useSelector((e: IEstadoGlobal) => e.estadoAutenticacion.usuarioInformacion!.IdUsuario);
    const [personas, setPersonas] = React.useState<IPersona[]>([]);
    const [
        { bodega, estadoFormularioBodegaPersona, tipoFormularioBodegaPersona, entidadBodegaPersona },
        dispatch,
    ] = useProveedor<IEstadoGestionBodegas>();
    const { alCambiarValor, setValor, reiniciar, valor } = useInputState<IInputsBodegasPersonas>(estadoInicial);

    React.useEffect(() => {
        cargarEntidadesFormulario();
    }, [bodega]);

    React.useEffect(() => {
        if (!estadoFormularioBodegaPersona) reiniciar();
    }, [estadoFormularioBodegaPersona]);

    React.useEffect(() => {
        if (entidadBodegaPersona && tipoFormularioBodegaPersona !== TipoFormulario.Creacion)
            setValor(entidadBodegaPersona);
    }, [entidadBodegaPersona]);

    const cerrarFormulario = () => {
        dispatch({ type: acciones.CAMBIAR_ESTADO_FORMULARIO_BODEGA_PERSONA, payload: null });
    };
    const confirmarCreacionEdicionBodegasPersonas = () => {
        if (bodegasPersonasCM.validarEntidad(mapearDatos())) {
            manejadorDialogoGlobal({
                accionCancelar: () => manejadorDialogoGlobal({ estado: false }),
                accionConfirmar: crearEditarBodegasPersonas,
                estado: true,
                mensaje: (
                    <Texto
                        id={
                            tipoFormularioBodegaPersona === TipoFormulario.Creacion
                                ? 'alerta.confirmacionCreacion'
                                : 'alerta.confirmacionEdicion'
                        }
                    />
                ),
                mostrarCancelar: true,
                tipoDialogo: 'Advertencia',
                titulo: <Texto id="titulo.advertencia" />,
            });
        }
    };

    const crearEditarBodegasPersonas = () => {
        manejadorDialogoGlobal({ estado: false });
        manejadorIndicadorCargaGlobal(true);
        if (tipoFormularioBodegaPersona === TipoFormulario.Creacion) {
            bodegasPersonasCM.crearBodegasPersonas(mapearDatos()).then(() => {
                cerrarFormulario();
                manejadorIndicadorCargaGlobal(false);
                dispatch({ type: acciones.RECARGAR_TABLA_BODEGA_PERSONA });
            });
        } else {
            bodegasPersonasCM.editarBodegasPersonas(mapearDatos()).then(() => {
                cerrarFormulario();
                manejadorIndicadorCargaGlobal(false);
                dispatch({ type: acciones.RECARGAR_TABLA_BODEGA_PERSONA });
            });
        }
    };

    const cargarEntidadesFormulario = async () => {
        if(bodega.EmpresaId!==""){
            console.log(bodega.EmpresaId);
            setPersonas(await entidadesBodegaPersonaCM.consultarListaPersonasPorEmpresa(bodega.EmpresaId));
        }
        
    };

    const mapearDatos = (): IBodegasPersonas => ({
        BodegaId: Number(bodega.BodegaId),
        EmpresaId: IdEmpresa,
        Estado: valor.Estado ? 1 : 0,
        PersonaId: valor.Persona ? valor.Persona.IdPersona! : '',
        BodegaPrincipal: valor.BodegaPrincipal,
        UsuarioId: valor.Persona!.IdUsuario! ? valor.Persona!.IdUsuario! : valor.UsuarioId!,
        AgenciaId: idAgencia!.IdAgencia,
    });

    return (
        <FormularioBodegasPersonasVista
            accionCrearEditar={confirmarCreacionEdicionBodegasPersonas}
            cambiarInfoFomulario={alCambiarValor}
            bodegasPersonas={valor}
            cerrarFormulario={cerrarFormulario}
            estadoFormulario={estadoFormularioBodegaPersona}
            personas={personas}
            tipoFormulario={tipoFormularioBodegaPersona}
        />
    );
};

const estadoAPropiedades = ({
    estadoAutenticacion: { usuarioInformacion },
}: IEstadoGlobal): IFormularioBodegasPersonasCVProps => ({ IdEmpresa: usuarioInformacion!.IdEmpresa });

export default connect<IFormularioBodegasPersonasCVProps, null, any, IEstadoGlobal>(
    estadoAPropiedades,
    null
)(FormularioBodegasPersonasCV);
